import { lazy } from "react";
import IRoute from "./IRoute";

const ViewStandingsPage = lazy(() => import("../pages/Standings/ViewStandingsPage"));

const standingsRoutes: IRoute = {
  path: "/standings",
  redirect: "/standings/view",
  children: [
    {
      path: "/view",
      component: ViewStandingsPage,
      needAuth: true,
    },
  ],
};

export default standingsRoutes;
